// extracted by mini-css-extract-plugin
export default {"content":"MainPage_content__TXWn4","button":"MainPage_button__Z5gYg"};